import { LogOut, User } from 'lucide-react'
import { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { signOut } from '@/lib/auth-client'
import {
	PortalShell,
	portalButton,
	portalButtonOutline,
	portalHeading,
	portalHeadingBar,
	portalLabel,
	portalPanel,
} from '@/routes/appointments/portal-shell'
import { trpc } from '@/trpc/client'

export function HomePage() {
	const navigate = useNavigate()
	const { data: user } = trpc.user.me.useQuery()
	const { data: voiceNew, error: voiceNewError } =
		trpc.voiceAgent.newCount.useQuery(undefined, {
			staleTime: 30000,
			refetchOnWindowFocus: true,
		})
	// A failed count renders the same as "0 new" — at least leave a trail.
	useEffect(() => {
		if (voiceNewError)
			console.error('[voice-agent] newCount query failed', voiceNewError)
	}, [voiceNewError])

	const onSignOut = async () => {
		await signOut()
		navigate('/login', { replace: true })
	}

	return (
		<PortalShell>
			<header className="border-b border-[#dedede] bg-white">
				<div className="mx-auto flex max-w-3xl items-center justify-between px-4 py-4 sm:px-6">
					{/* Text rendition of the site logo */}
					<div className="flex items-center gap-3">
						<p className={`${portalHeading} text-2xl leading-none`}>Josenika</p>
						<span className={`${portalLabel} text-sm`}>Interní systém</span>
					</div>
					<div className="flex items-center gap-4">
						{user && (
							<span className="flex items-center gap-2 text-sm">
								<User className="h-4 w-4 text-[#d7ad6c]" />
								{user.name || user.email}
							</span>
						)}
						<Button
							className={portalButtonOutline}
							size="sm"
							onClick={onSignOut}
						>
							<LogOut className="mr-2 h-4 w-4" />
							Odhlásit se
						</Button>
					</div>
				</div>
			</header>

			<main className="mx-auto max-w-3xl px-4 py-10 sm:px-6 sm:py-14">
				<div className="mb-10 text-center">
					<h1
						className={`${portalHeading} text-[28px] leading-tight sm:text-[34px]`}
					>
						Vítejte
					</h1>
					<div className="mx-auto mt-4 h-[2px] w-[55px] bg-[#d7ad6c]" />
				</div>

				<div className="mx-auto max-w-md">
					<section className={`${portalPanel} p-6 sm:p-8`}>
						<h2
							className={`${portalHeading} ${portalHeadingBar} mb-6 text-[22px] leading-tight`}
						>
							Kalendář
						</h2>
						<div className="flex flex-col gap-3">
							<Button asChild className={`${portalButton} h-11 w-full`}>
								<Link to="/calendar/zub">Zubní ordinace</Link>
							</Button>
							<Button asChild className={`${portalButton} h-11 w-full`}>
								<Link to="/calendar/dh">Dentální hygiena</Link>
							</Button>
							<Button asChild className={`${portalButton} h-11 w-full`}>
								<Link to="/voice-agent">
									Hlasový agent
									{voiceNew && voiceNew.count > 0 && (
										<span className="ml-2 inline-flex h-5 min-w-5 items-center justify-center bg-white px-1 text-[11px] font-semibold text-[#d7ad6c]">
											{voiceNew.count}
										</span>
									)}
								</Link>
							</Button>
							<Button asChild className={`${portalButtonOutline} h-11 w-full`}>
								<Link to="/settings">Nastavení</Link>
							</Button>
						</div>
					</section>
				</div>
			</main>
		</PortalShell>
	)
}
